import { atom } from "recoil";
export const selectedVIPTab = atom({
  key: "selectedVIPTab",
  default: 0,
});
